import { useCallback, memo } from "react";
import React from "react";

const ToolParamInvoker = (params: any) => {
  const { value, handleClick, label, data, colDef } = params;
  

  // Get the field dynamically from colDef
  const fieldKey = colDef?.field;
  //const invoiceLink = data?.[fieldKey];
  const invoiceLink = data?.[colDef?.field] || "";




  const onLinkClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      if (handleClick && invoiceLink) {
        handleClick(params, { pdfData: invoiceLink });
      }
    },
    [handleClick, params, invoiceLink]
  );




  return (
    <div onClick={onLinkClick} title={value}>
      <div
        role="button"
        className="link-primary text-truncate"
        style={{ cursor: invoiceLink ? "pointer" : "default", color: invoiceLink ? "blue" : "gray" }}
      >
        {invoiceLink ? "View Invoice" : "No Invoice"}
      </div>
    </div>
  );
};

export default memo(ToolParamInvoker);
